import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import { Gateway } from 'react-gateway';
import classnames from 'classnames';

const Subtitle = ({ children, className }) => {
  if (isEmpty(children)) return null;
  return (
    <Gateway into="subtitle">
      <h3 className={classnames('c-heading c-heading--huge u-mv', className)}>
        { children }
      </h3>
    </Gateway>
  );
};
Subtitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
Subtitle.defaultProps = {
  className: '',
};

export default Subtitle;



// WEBPACK FOOTER //
// ./src/app/components/Subtitle.jsx